var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultSocketOptions, } from './framework/CommandSocket';
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class Alfatron {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: '/^Version;',
                next: /V\s*[\d\.]+|CMD Error|Please Input Your Command/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // Not all product models support a power query function.  All support power on/off.
        this.models = {
            '-N6nJ4LOuesJ--4fd8X3': { hasPowerGet: true, name: 'Blackbird 4K 4x4 HDMI Matrix' },
            '-MOXx3AJGUqKWYUdUyi7': { hasPowerGet: true, name: 'MUH44A-RS' },
            '-MOXx6Kr4MatisSqkuMi': { hasPowerGet: true, name: 'MUK44A' },
            '-MOXx8rae1pv4lG2oeXi': { hasPowerGet: true, name: 'MUH44E' },
            '-MOXxBaA8r6vWuXO4bZG': { hasPowerGet: true, name: 'MUH44TP-N' },
            '-MOXxEqreg9GFsTZzFDk': { hasPowerGet: true, name: 'MUK88A' },
            '-NApCbVU_UaQDhUvOqBs': { avSwitchCmd: 'B', name: 'MUH88A-N' },
            '-MOXxHUvEYyfgxxTJFcT': { hasPowerGet: true, name: 'MUH88TP-N' },
            '-MOXxMSuhfjJZMIS6wmQ': { hasPowerGet: true, name: 'MUH88E' },
            '-MOXxJjJlUS1V2OKz8tB': { hasVolume: true, hasPowerGet: true, name: 'SM62T' },
            '-MotsO1X4pF38dE1IRjt': { avSwitchCmd: 'B', name: 'MMX88A-N' },
            '-NAH2ZFOhQdXDD2LBlf4': { avSwitchCmd: 'B', name: 'MMX16x16-N' },
        };
        this.defaultModelNumber = '-MOXx3AJGUqKWYUdUyi7';
        this.model = this.models[this.defaultModelNumber];
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`/^Version;`, /V\s*([\d\.]+)|CMD Error/i, tags);
                return match[1] ? match[1] : 'unknown';
            }),
            powerOffRestrictions: ['get'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                if ((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.hasPowerGet) !== null && _b !== void 0 ? _b : false) {
                    const match = yield this.socket.send(`%9962.`, /(STANDBY|PWOFF|PWON)|CMD Error/i, tags);
                    if (match[1])
                        return match[1] === 'PWON';
                }
                return this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`${power ? 'PWON.' : 'PWOFF.'}`, /(STANDBY|PWOFF|PWON)/i, tags, { sendTimeoutMs: 6000 } // ack upon power on takes longer
                );
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 20000 : 1000);
                // Takes about 20 seconds after power up before it accepts commands again.
                this.framework.suspend(power ? 20000 : 1000);
                return match[1] === 'PWON';
            }),
            isStateless: (config) => {
                var _a, _b;
                return !((_b = (_a = this.model) === null || _a === void 0 ? void 0 : _a.hasPowerGet) !== null && _b !== void 0 ? _b : false);
            },
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`Status${key}.`, /(?:A)?V\s*:\s*(\d+)\s*->\s*(\d+)|IR:\d+->\d+/i, // input -> output
                tags);
                if (match[1] && match[2])
                    return parseInt(match[1], 10).toString(); // Remove leading 0's
                return this.state.videoMatrixRoutes.values[key];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                var _c, _d;
                const match = yield this.socket.send(`${value}${(_d = (_c = this.model) === null || _c === void 0 ? void 0 : _c.avSwitchCmd) !== null && _d !== void 0 ? _d : 'V'}${key}.`, /(?:A)?V\s*:\s*(\d+)\s*->\s*(\d+)|(\d+)B(\d+)/i, // input -> output
                tags);
                if (match[1])
                    return parseInt(match[1], 10).toString(); // Remove any leading 0's
                if (match[3])
                    return parseInt(match[3], 10).toString();
                return this.state.videoMatrixRoutes.values[key];
            }),
            asyncHandlers: [
                {
                    regExp: /(?:A)?V\s*:\s*(\d+)\s*->\s*(\d+)/i,
                    callback: (match) => {
                        const value = parseInt(match[1], 10).toString();
                        const key = parseInt(match[2], 10).toString();
                        this.state.videoMatrixRoutes.update(key, value);
                    },
                },
                {
                    regExp: /(\d+)B(\d+)/i,
                    callback: (match) => {
                        const value = parseInt(match[1], 10).toString();
                        const key = parseInt(match[2], 10).toString();
                        this.state.videoMatrixRoutes.update(key, value);
                    },
                },
            ],
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%9930.`, /Volume of Master\s*:\s*(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SetMasterVol:${volume}`, /Volume of Master\s*:\s*(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            range: { max: 100, min: 0, round: 1 },
            asyncHandlers: {
                regExp: /Volume of Master\s*:\s*(\d+)/i,
                callback: (match) => {
                    this.state.volume.update(parseInt(match[1], 10));
                },
            },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                var _e, _f;
                return (_f = (_e = this.model) === null || _e === void 0 ? void 0 : _e.hasVolume) !== null && _f !== void 0 ? _f : false;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`%9923.`, /Master (Mute|Unmute)/i, tags);
                return match[1].toLowerCase() === 'mute';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`${mute ? 'MasterMute' : 'MasterUnmute'}.`, /Master (Mute|Unmute)/i, tags);
                return match[1].toLowerCase() === 'mute';
            }),
            asyncHandlers: {
                regExp: /Master (Mute|Unmute)/i,
                callback: (match) => {
                    this.state.volumeMute.update(match[1].toLowerCase() === 'mute');
                },
            },
            hasControl: (config) => __awaiter(this, void 0, void 0, function* () {
                var _g, _h;
                return (_h = (_g = this.model) === null || _g === void 0 ? void 0 : _g.hasVolume) !== null && _h !== void 0 ? _h : false;
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                controls: ['power', 'videoMatrixRoutes'],
            },
        ];
    }
    // phase callbacks
    onBeforeConfigure(config) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const modelNumber = (_a = config === null || config === void 0 ? void 0 : config.modelNumber) !== null && _a !== void 0 ? _a : this.defaultModelNumber;
            this.model = (_b = this.models[modelNumber]) !== null && _b !== void 0 ? _b : this.models[this.defaultModelNumber];
            // Set idle timeout to 0 for devices that can't query power (assuming other controls can't
            // be queried while powered off either).
            const socketTimeoutMs = ((_c = this.model) === null || _c === void 0 ? void 0 : _c.hasPowerGet) ? defaultSocketOptions.idleTimeoutMs : 0;
            this.socket.setIdleTimeoutMs(socketTimeoutMs);
        });
    }
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
Alfatron.driverType = 'socketDriver';
Alfatron.key = '-MOXwaLNGaqzPZh3nEnK';
Alfatron.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
Alfatron.socketOptions = [
    Object.assign(Object.assign({}, Alfatron.baseSocketOptions), { port: 4001 }),
    Object.assign(Object.assign({}, Alfatron.baseSocketOptions), { port: 4999 }),
];
